import { reviews } from '@/mocks/comics';

export default function ReviewSection() {
  const col1 = reviews.slice(0, 2);
  const col2 = reviews.slice(2, 4);
  const col3 = reviews.slice(4, 6);

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-2">
          <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-400 bg-background-200/60 rounded-full">
            读者原声
          </span>
        </div>
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50 leading-tight">
            万千读者的
            <br />
            真实评价
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[col1, col2, col3].map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-6">
              {col.map((review) => (
                <div
                  key={review.id}
                  className="p-6 rounded-2xl bg-background-200/50 hover:bg-background-200/70 transition-colors duration-200"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatar}
                      alt={review.username}
                      className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                    />
                    <div>
                      <div className="text-sm font-semibold text-foreground-200">{review.username}</div>
                      <div className="text-xs text-foreground-600">{review.handle}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}